import { useState } from "react";
import { useHistory } from "react-router-dom";
import * as API from "../http/api";
import * as Modals from "./modals";
import banner from "../images/sideBar.png";
import { openlightbox } from "../util/Functions";

import { Logout, SupervisedUserCircleOutlined, LocalLibraryOutlined, InfoOutlined, ExpandMore, ExpandLess} from "@mui/icons-material";
import { Grid, Box, ListItemButton, ListItemIcon, ListItemText, SwipeableDrawer } from "@mui/material";
import { ThemeProvider } from '@mui/material/styles';
import { SideBarStyle, theme } from "../util/TableStyles";

const SideBar = (props) => {
	const history = useHistory();

	const logout = async () => {
		props.closeSideBar()
		let response = await API.logout();
		if (response.status === 200) {
			delete localStorage.session;
			delete localStorage.config;
			history.push("/login", { logout: true });
		}
	};

	const pages = [
		{ref: "https://albocare.freshdesk.com/", label: "Freshdesk" },
		{ref: "https://prod.stpmex.com/spei/?wicket:bookmarkablePage=:com.lgec.enlacefi.spei.web.login.STPEILoginPage", label: "STP" },
		{ref: "https://www.banxico.org.mx/cep/", label: "Banxico" },
		{ref: "https://mydhl.express.dhl/mx/es/shipment.html#/#address-details", label: "DHL" },
		{ref: "https://v2.ivoy.mx/client/app/ivoy/step1", label: "iVoy" },
		{ref: "https://docs.google.com/forms/d/e/1FAIpQLSeDB6yN8TTsbWMtRumb9CbfTCa4Uek56dGaSpgLXc1nt-XQzg/viewform", label: "Logística" },
		{ref: "https://chocolate2.cacaopaycard.com/", label: "Chocolate" },
		{ref: "https://cacaopaycard.freshdesk.com/", label: "Freshdesk Cacao" },
	]

	const [active, setActive] = useState(false);
	const colapse = () => {
		active ? setActive(false) : setActive(true);
	};

	const openTab = (url) => {
		props.closeSideBar()
		window.open(url);
	};

	const openModal = () => {
		props.closeSideBar()
		let contentModal = {
			title: "Cambiar rol",
		};
		const as = (
			<Modals.ChangeRol
				pos={props.pos}
				contentModal={contentModal}
				changeAlert={props.changeAlert}
				changeLoader={props.changeLoader}
				key="changeRol"
			/>
		);
		openlightbox(as);
	};

	const providers = () => {
		return <Box display={"grid"} ml={"4.5rem"} fontSize={"0.78rem"}>
			{pages.map((item, index) => {
				return <Box key={`provider-${index}`} component={"a"} href={item.ref} rel="noopener noreferrer" target="_blank" pt={"0.45rem"}>{item.label}</Box>
			})}
		</Box>
	}

	return (
		<SideBarStyle>
		<SwipeableDrawer anchor="right" open={props.showSideBar} onOpen={props.openSideBar.bind(this)} onClose={props.closeSideBar.bind(this)}>
		<ThemeProvider theme={theme}>
			<Grid container sx={{height: '100vh', pb: "28px"}} display={'flex'} alignContent={'space-between'} width={"16rem"}>
				<Grid item width={"100%"}>
					<Box component="img" alt="banner" src={banner} width={"100%"}/>
					{localStorage.config && JSON.parse(localStorage.config)["changeRol"] &&
						<ListItemButton onClick={openModal.bind(this)}>
							<ListItemIcon><SupervisedUserCircleOutlined/></ListItemIcon>
							<ListItemText primary="Cambiar rol" />
						</ListItemButton>
					}
					<ListItemButton onClick={openTab.bind(this, "https://albomx.atlassian.net/wiki/spaces/INext/pages/855179396/ndigoNext" )}>
						<ListItemIcon><LocalLibraryOutlined/></ListItemIcon>
						<ListItemText primary="Capacitación" />
					</ListItemButton>
					<ListItemButton onClick={colapse.bind(this)}>
						<ListItemIcon><InfoOutlined/></ListItemIcon>
						<ListItemText primary="Proveedores" sx={{pr: "7rem"}} />
						<ListItemIcon>{active ? <ExpandLess/> : <ExpandMore/> }</ListItemIcon>
					</ListItemButton>
					{active && providers()}
				</Grid>

				<Grid item width={"100%"}>
					<ListItemButton onClick={logout.bind(this)}>
						<ListItemIcon><Logout/></ListItemIcon>
						<ListItemText primary="Cerrar sesión" />
					</ListItemButton>
				</Grid>
			</Grid>
		</ThemeProvider>
		</SwipeableDrawer>
		</SideBarStyle>
	);
};

export default SideBar;